import { useRouter } from 'next/router'
import qs from 'qs'
import { FC } from 'react'
import ReactPaginate from 'react-paginate'
import ArrowLeftSLineIcon from 'remixicon-react/ArrowLeftSLineIcon'
import ArrowRightSLineIcon from 'remixicon-react/ArrowRightSLineIcon'

import clsxm from '@/utils/clsxm'

const Pagination: FC<{
  selected: number
  perPage: number
  totalData: number
  onPageChange: (event: { selected: number }) => void
  hrefBuilder?: string
}> = ({ selected, perPage, totalData, onPageChange, hrefBuilder }) => {
  const baseClass =
    'flex h-8 w-8 items-center justify-center rounded-[32px] border-[1px] border-neutral-border bg-white text-black text-xs font-semibold fill-[#212121]'
  const router = useRouter()

  return (
    <>
      <ReactPaginate
        breakLabel='...'
        activeLinkClassName={clsxm(baseClass, '!bg-red !text-white')}
        disabledLinkClassName={clsxm(baseClass, '!bg-neutral-disable !text-gray-3 fill-gray-3')}
        breakLinkClassName={baseClass}
        previousLinkClassName={baseClass}
        nextLinkClassName={baseClass}
        pageLinkClassName={baseClass}
        nextLabel={<ArrowRightSLineIcon size={16} />}
        previousLabel={<ArrowLeftSLineIcon size={16} />}
        className='flex items-center justify-between gap-3 self-center bg-white'
        marginPagesDisplayed={0}
        pageRangeDisplayed={3}
        onPageChange={onPageChange}
        pageCount={Math.ceil(totalData / perPage)}
        forcePage={selected}
        renderOnZeroPageCount={null}
        hrefBuilder={(pageIndex) => `${hrefBuilder}?page=${pageIndex}&${qs.stringify(router?.query)}`}
        // hrefBuilder={hrefBuilder ? (pageIndex) => `${hrefBuilder}?page=pageIndex` : undefined}
      />
    </>
  )
}

export default Pagination
